import * as helpers from "./lightbox_helpers"
import { LightBoxEvents } from "./lightbox_events.js"
import { PixleeCarousel, ReviewsHelper } from "./lightbox";

export function PixleeHotspots(hotspotsElem) {
    var _this = this;
    var HOTSPOT_TEMPLATE = require('./templates/hotspots/_hotspot.jst.ejs');
    var HOTSPOT_CONTAINER_CLASS = '.hotspot_marker_container';
    var HOTSPOT_MARKER_CLASS = '.hotspot_marker';
    var hotspots = [];
    var hotspotsHolder;
    var hotspotsMap = {};
    var hotspotsIndexMap = [];
    var productCtas;
    var hotspotsVisible = true;
    var hammertime;

    this.ctaProductIndex = 0;
    this.animatingVisibility = false;
    this.holdPeekingHotspot = false;
    this.peekingHotspot = null;
    this.listenerAttached = false;

    // Initially defined in lightbox_helpers.js as false.
    // We set it to true here once a PixleeHotspots object is instantiated
    helpers.setEnableHotspots(true);

    /**
     * @param displayOptions Object
     * @param data Object : photo object
     * @description The photo object has a bounding_box_products object and a products object.
     *              We want to stitch the product and bounding box together
     **/
    this.setHotspots = function(displayOptions, currentAlbum, data) {
        hotspots = [];
        var products = data.products;
        var validDomains;

        // Item (photo) has some CTA, we don't render hotspots in that case
        if (helpers.photoHasCta(data)) {
            return;
        }

        //Don't show products on their own PDP page, unless that customer explicitly has it turned on (pdp_self_link)
        products = helpers.filterProductsByPDP(currentAlbum, products);

        // Assign the correct CTA link to each product, depending on the domain
        products = products.map(function(prod) {
            prod.link = helpers.formatLink(prod.link, currentAlbum, displayOptions, prod.extra_urls);
            return prod;
        });

        //check account for valid domain mappings
        if (!_.isFalsy(gon.current_account.extra_fields) && !_.isFalsy(gon.current_account.extra_fields.valid_product_domains)) {
            validDomains = gon.current_account.extra_fields.valid_product_domains;
        }

        //if the product is not from the whitelisted domains, remove it from the product array, and move on
        if (!_.isEmpty(validDomains)) {
            products = helpers.filterProductsByDomain(validDomains, products);
        }

        for (var i = 0; i < products.length; i++) {
            var templateData = products[i];

            if (displayOptions.hotspots && data.content_type === 'image') {
                var productBoundingBox = _.find(data.bounding_box_products, function(boundingBox) {
                    return boundingBox.product_id === templateData.id;
                });

                if (!_.isFalsy(productBoundingBox)) {
                    productBoundingBox.index = i;
                    productBoundingBox.productName = products[i].title;
                    hotspots.push(productBoundingBox);
                }
            }
        }

        data.hotspots = hotspots;
        hotspotsVisible = true;
    }

    /**
     * @param Integer index : the index of the hotspot
     * @description Remove any active hotspot and set one of the hotspot active
     **/
    this.setActiveHotspot = function(index) {
        var hotspotsHolder = $(hotspotsElem);
        var elem = hotspotsIndexMap[index];

        hotspotsHolder.find(HOTSPOT_MARKER_CLASS).removeClass('active');

        if (!_.isFalsy(elem)) {
            elem.addClass('active');
        }

        this.peekActiveHotspot(elem);
    }

    /**
     * @description Creates a click listener on the hotspot holder to toggle hotspots visibility.
     * For Mobile/Tablet
     **/
    this.setToggleVisibilityOnTap = function() {
        if (this.listenerAttached) {
            return;
        }

        var hotspotsHolder = $(hotspotsElem);
        hotspotsHolder.click(function(event) {
            this.toggleHotspots(!hotspotsVisible);
        }.bind(this));
        this.listenerAttached = true;
    }

    /**
     * @description Creates a hover listener on the hotspot holder to toggle hotspots visibility.
     * For Desktop
     **/
    this.setToggleVisibilityOnHover = function() {
        if (this.listenerAttached) {
            return;
        }

        var hotspotsHolder = $(hotspotsElem);
        hotspotsHolder.hover(
            function(event) {
                this.toggleHotspots(true);
            }.bind(this),
            function(event) {
                this.toggleHotspots(false);
            }.bind(this)
        );
        this.listenerAttached = true;
    }

    /**
     * @description Creates a hover listener on the cta holder to toggle hotspots visibility.
     * For Desktop
     * Note: triggerElems captures every element that is passed into the function and wraps it as an array
     * In the future, if we wanted to target more elements with the same behaviour, we can just pass in it as another param
     **/
    this.setPeekActiveHotspotTrigger = function() {
        var triggerElems = Array.prototype.slice.call(arguments);
        $.each(triggerElems, function(index, elem) {
            elem.on({
                'mouseenter': mouseAction.bind(this, true),
                'mouseleave': mouseAction.bind(this, false)
            });
        }.bind(this));
    }

    var mouseAction = function(toggle) {
        this.holdPeekingHotspot = toggle;
        this.toggleActiveHotspot(toggle);
    }

    this.toggleHotspots = function(isVisible) {
        this.finishHotspotAnimations();

        if (this.animatingVisibility || hotspotsVisible === isVisible) {
            return;
        }

        var _this = this;
        var hotspotsHolder = $(hotspotsElem);
        hotspotsHolder.find(HOTSPOT_CONTAINER_CLASS).each(function() {
            var selector = $(this);
            var hotspotMarker = selector.find(HOTSPOT_MARKER_CLASS);

            if (selector.is(':first-child')) {
                _this.animatingVisibility = true;
            }

            if (isVisible) {
                selector.css('visibility', 'visible');
            }

            _this.animatingVisibility = true;

            hotspotMarker.animate({
                opacity: isVisible ? 1 : 0
            }, {
                duration: isVisible ? 250 : 400,
                easing: 'easeOutBack',
                step: function(now, fx) {
                    hotspotMarker.css('transform', 'scale(' + now + ')');
                },
                complete: function() {
                    if (!isVisible) {
                        selector.css('visibility', 'hidden');
                    }
                    if (selector.is(':last-child')) {
                        _this.animatingVisibility = false;
                    }
                }
            });
        });
        hotspotsVisible = isVisible;
    }

    this.toggleActiveHotspot = function(isVisible, elem, delay) {
        if (hotspotsVisible) {
            return;
        }
        this.finishHotspotAnimations();

        if (typeof elem === 'undefined') {
            elem = hotspotsIndexMap[this.ctaProductIndex];

            if (_.isFalsy(elem)) {
                return;
            }
        }
        if (typeof delay === 'undefined') {
            delay = 0;
        }

        var elemContainer = elem.parent();

        if (isVisible) {
            elem.delay(delay).animate({
                opacity: 1
            }, {
                duration: this.isHotspotPeeking ? 0 : 175,
                easing: 'easeInOutExpo',
                start: function() {
                    this.animatingVisibility = true;
                    this.peekingHotspot = elem;
                    elemContainer.css('visibility', 'visible');
                    elem.css('transform', 'scale(1)');
                }.bind(this),
            });
        } else {
            elem.delay(delay).animate({
                opacity: 0
            }, {
                duration: 500,
                easing: 'easeOutSine',
                complete: function() {
                    elemContainer.css('visibility', 'hidden');
                    elem.css('transform', 'scale(0)');
                    this.animatingVisibility = false;
                    this.peekingHotspot = null;
                }.bind(this),
            });
        }
    }

    /**
     * @description If hotspot visibility is turned off, we want to the hotspot to peek active when they switch a product
     **/
    this.peekActiveHotspot = function() {
        if (hotspotsVisible) {
            return;
        }

        var elem = hotspotsIndexMap[this.ctaProductIndex];

        if (!_.isFalsy(this.peekingHotspot)) {
            this.toggleActiveHotspot(false, this.peekingHotspot, 0);
        }

        this.toggleActiveHotspot(true, elem, 0);

        // For Mobile/Tablet, this.holdPeekingHotspot will always be false because it is intended for the delay hide to happen
        if (!this.holdPeekingHotspot) {
            this.toggleActiveHotspot(false, elem, 350);
        }
    }

    this.finishHotspotAnimations = function() {
        hotspotsIndexMap.forEach(function(elem) {
            elem.finish();
        });
    }

    this.getCtaProductIndex = function() {
        return this.ctaProductIndex;
    }

    this.setCtaProductIndex = function(index, activateCurrentHotSpot) {
        this.ctaProductIndex = index;

        if (activateCurrentHotSpot) {
            this.setActiveHotspot(index);
        }
    }

    this.getHotspots = function() {
        return hotspots;
    }

    var trackHotspotClick = function() {
        var magnificPopupItem = helpers.magnificPopup.items[helpers.magnificPopupIndex];
        var data = magnificPopupItem.data;
        var albumPhotoId = data.album_photo_id;

        LightBoxEvents.HotspotsClicked(albumPhotoId);
    }

    /**
     * @param Object hotspot click event
     * @description When a hotspot gets clicked, set it to active
     **/
    var hotspotClick = function(index, prodContainer, event) {
        if (!hotspotsVisible) {
            return false;
        }

        trackHotspotClick();
        var selected = $(event.currentTarget);
        var magnificPopupItem = helpers.magnificPopup.items[helpers.magnificPopupIndex];
        var data = magnificPopupItem.data;

        if (!selected.hasClass('active')) {
            this.setCtaProductIndex(index, true);

            var productCtas = prodContainer.children();

            productCtas.addClass('invalid');
            $(productCtas[index]).removeClass('invalid');
        }

        if (helpers.enableLightboxReviews) {
            ReviewsHelper.generateReview(data.products[index]);
        }

        if (helpers.enableCarousel) {
            PixleeCarousel.goToIndex(index);
        }

        return false;
    };

    /**
     * @description If there's hotspots, the holder cover up the image so the hammertime on that doesn't get activated.
     *              So got to create a hammertime on the hotspot holder.
     **/
    var createHammertime = function(target) {
        if (gon.isMobile || gon.isTablet) {
            var leftArrow = $('.mfp-arrow-left');
            var rightArrow = $('.mfp-arrow-right');

            if (hammertime) {
                hammertime.destroy();
            }

            hammertime = new Hammer(target);

            hammertime.on('swipe', function(ev) {
                if (ev.direction === 2) {
                    rightArrow.click();
                } else if (ev.direction === 4) {
                    leftArrow.click();
                }
            });
        }
    }

    /**
     * @description When the lightbox closes, destroy the hammertime on top of the hotspot holder
     **/
    this.destroyHammertime = function() {
        if (hammertime) {
            hammertime.destroy();
        }
    }

    /**
     * @description This is where the magic happens, the hotspots gets created!
     * In mobile/tablet, reviews take over hotspots. don't bother rendering hotspots.
     * A timeout is set for 150ms to account for when magnificPopup is shown because defaultHeightWidth needs to read the width to calculate
     **/
    this.renderHotspots = function() {
        setTimeout(function() {
            if (_.isFalsy(helpers.magnificPopup)) {
                return;
            }
            var magnificPopupItem = helpers.magnificPopup.items[helpers.magnificPopupIndex];
            var image = magnificPopupItem.img.get(0);
            var hotspotsHolder = $(hotspotsElem);
            var prodContainer = $('#cta_container');
            var hideHotspots = (gon.isMobile || gon.isTablet) && (magnificPopupItem.data.selectedReviewInfo && magnificPopupItem.data.selectedReviewInfo.active);

            if (!_.isFalsy(hotspots) && !hideHotspots) {
                createHammertime(hotspotsHolder[0]);

                /*
                 * Hotspots calculation. * This calculation is the same in CP *
                 * defaultHeightWidth: The width/height of the hotspot/ugc holder
                 * naturalHeight, naturalWidth: Natural height/width of the image
                 * height, width: The height/width  of the image with respect to hotspotsHolder size restriction
                 * heightRatio, widthRatio: The ratio of the natural width/height to the size of hotspotsHolder
                 * topOffset, leftOffSet: How far the UGC is away from the top, left of hotspotsHolder to determine where co-ord (0,0) starts
                 *                        with respect to the hotspotsHolder
                 * leftThird, topThird: The hotspot is place 1/3rd from the top and left of the bounding box
                 * setLeft, setTop: The co-ords of the hotspots (setLeft, setTop)
                 */
                for (var i = 0; i < hotspots.length; i++) {
                    var boundingBox = hotspots[i];

                    if (boundingBox && typeof boundingBox.x === 'number' && typeof boundingBox.y === 'number') {
                        var defaultHeightWidth = hotspotsHolder.width();
                        var naturalHeight = image.naturalHeight;
                        var naturalWidth = image.naturalWidth;

                        var height = defaultHeightWidth * (naturalHeight / naturalWidth);
                        var width = defaultHeightWidth * (naturalWidth / naturalHeight);

                        var topOffSet = 0;
                        var leftOffSet = 0;
                        if (naturalHeight !== naturalWidth) {
                            if (naturalHeight > naturalWidth) {
                                height = defaultHeightWidth;
                                leftOffSet = (naturalHeight - naturalWidth) / 2;
                            } else {
                                width = defaultHeightWidth;
                                topOffSet = (naturalWidth - naturalHeight) / 2;
                            }
                        }

                        var heightRatio = naturalHeight / height;
                        var widthRatio = naturalWidth / width;

                        var leftThird = boundingBox.width / 3;
                        var topThird = boundingBox.height / 3;

                        var setLeft = (boundingBox.x + leftOffSet + leftThird) / widthRatio;
                        var setTop = (boundingBox.y + topOffSet + topThird) / heightRatio;
                        var attributes = {
                            'left': setLeft / defaultHeightWidth * 100,
                            'top': setTop / defaultHeightWidth * 100,
                            'productName': hotspots[i].productName
                        };

                        var elemTemplate = HOTSPOT_TEMPLATE(attributes);
                        var elemContainer = $(elemTemplate);

                        elemContainer.click(hotspotClick.bind(this, boundingBox.index, prodContainer));

                        hotspotsIndexMap[boundingBox.index] = elemContainer.find(HOTSPOT_MARKER_CLASS);
                        hotspotsHolder.append(elemContainer);
                    }
                }
            }

            var activeElem = hotspotsIndexMap[this.ctaProductIndex]

            if (activeElem) {
                activeElem.addClass('active');
            }
        }.bind(this), 150);
    }

}
